import { render, staticRenderFns } from "./JobDetail.vue?vue&type=template&id=f80e089a&"
import script from "../../../services/admin/job/job-detail.js?vue&type=script&lang=js&"
export * from "../../../services/admin/job/job-detail.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports